define(["require", "exports", "./design"], function (require, exports, design_1) {
    "use strict";
    exports.__esModule = true;
    exports.isLandscape = function () { return window.innerWidth > window.innerHeight; };
    var extraHeight = function (box) { return box.offsetHeight - window.innerHeight; };
    exports.shouldShowScrollTip = function (box) { return exports.isLandscape() && extraHeight(box) > 10; };
    var asBox = function (rect) { return ({
        topLeft: { X: rect.left, Y: rect.top },
        size: { Width: rect.width, Height: rect.height }
    }); };
    exports.isInViewport = function ($cur) {
        var pos = asBox($cur[0].getBoundingClientRect());
        var viewport = asBox(new DOMRect(window.scrollX, window.scrollY, window.innerWidth, window.innerHeight));
        return design_1.covers(viewport, pos);
    };
    exports.offsetYIntoViewPort = function ($cur) {
        var pos = asBox($cur[0].getBoundingClientRect());
        var viewport = asBox(new DOMRect(window.scrollX, window.scrollY, window.innerWidth, window.innerHeight));
        var posBottom = pos.topLeft.Y + pos.size.Height;
        var viewportBottom = viewport.topLeft.Y + viewport.size.Height;
        return { X: 0, Y: Math.max(0, posBottom - viewportBottom) };
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/viewport.js
// module id = 90
// module chunks = 0